import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  popoverPaper: {
    '&.top': {
      marginTop: -16,
    },

    '&.bottom': {
      marginTop: 16,
    },
  },
  popper: {
    '&[x-placement*="top"]': {
      top: '-8px !important',
    },

    '&[x-placement*="bottom"]': {
      top: '8px !important',
    },
  },
}));
